import React from "react";
import {Box} from '@mui/material';
import CustomAppBar from '../components/appbar';
import BidList from "../components/activeBidLists";

const ActiveBids = () => {
    return (
        <Box>
            <CustomAppBar active="active"/>
            <BidList/>
        </Box>
    );
}

export default ActiveBids;